import ReactPixel from 'react-facebook-pixel';

const pixelId = process.env.REACT_APP_META_PIXEL_ID || ""; 

export const initMetaPixel = () => {
  ReactPixel.init(pixelId);
  ReactPixel.pageView();
};

export const trackMetaEvent = (event: string, data?: Record<string, any>) => {
  ReactPixel.track(event, data);
};